<script setup lang="ts"></script>
<template>
	<div>
		<nuxt-page />

		<footer-campaign />
	</div>
</template>
